import React, { useEffect, useState } from 'react'
import CardPastPrescription from '../../../../components/CardPastPrescription'
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Pagination } from 'antd';

function Pastprescriptions({ patientId, FlagFetchMain }) {
    const API_URL = import.meta.env.VITE_API_URL;
    const [prescriptions, setPrescriptions] = useState([]);
    const accessToken = useSelector((state) => state.user.accessToken);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5,
        total: 0
    });
    const fetchPrescriptions = async () => {
        try {
            const params = {
                page: pagination.current,
                limit: pagination.pageSize,
                userId: patientId
            };

            const response = await axios.get(`${API_URL}Prescriptions/get-prescriptions`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params
            });

            setPrescriptions(response.data.Prescriptions);
            setPagination(prev => ({
                ...prev,
                total: response.data.totalCount
            }));
        } catch (error) {
            console.error('Error fetching prescriptions:', error);
        }
    };
    const [FlagFetch, setFlagFetch] = useState(0)

    useEffect(() => {
        fetchPrescriptions();
    }, [pagination.current, pagination.pageSize, patientId, FlagFetch, setFlagFetch,FlagFetchMain]);

    const handlePaginationChange = (page, pageSize) => {
        setPagination(prev => ({
            ...prev,
            current: page,
            pageSize: pageSize
        }));
    };

    return (
        <>
            {prescriptions.length == 0 ? (
                <div className='bg-white p-5 rounded mb-5 h-[50vh] flex justify-center items-center'>
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <p style={{ fontSize: "16px", fontWeight: "400", }}>No Prescriptions</p>
                    </div>
                </div>
            ) : <div className='bg-white p-5 rounded'>
                {prescriptions.map((prescription) => (
                    <div key={prescription.id}>
                        {prescription.PrescribedMedicines.map((medicine) => (
                            <CardPastPrescription
                                key={medicine.id}
                                data={medicine}
                                userId={patientId}
                                ConditionName={prescription.name}
                                setFlagFetch={setFlagFetch}

                            />
                        ))}
                    </div>
                ))}
            </div>} {
                <div className='flex justify-end mt-4'>
                    <Pagination
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                        onChange={handlePaginationChange}
                        showSizeChanger
                        onShowSizeChange={handlePaginationChange}
                        pageSizeOptions={['10', '20', '50']}
                    />
                </div>
            }
        </>

    )
}

export default Pastprescriptions;
